import { Mutation } from 'vuex'
import { ModalState } from '../types'

const toggleModal: Mutation<ModalState> = (state, { showed, ...modal }) => {
  state.current = showed ? modal : null
}

export default toggleModal
